import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const IPay88PaymentMob = () => {
  return <DataFormSubmitPage />;
};

export default IPay88PaymentMob;
